import { useNavigate } from "react-router-dom"

export const useInsurance = () => {
    const navigate = useNavigate();
    const faqs = [
        {
            question: "O que o Bmg Med oferece?",
            answer: `Com o Bmg Med você tem assistência à saúde com acesso fácil a consultas e outros benefícios como:

Consultas Online (Telemedicina) 24h com o clínico geral;
Consultas presenciais por R$50 em várias especialidades;
Descontos em exames e procedimentos;
Desconto em medicamentos: são quase 7 mil farmácias e mais de 3 mil clínicas e médicos conveniados.`,
        },
        {
            question: "Quem pode contratar o Bmg Med?",
            answer: "O Bmg Med pode ser contratado com qualquer cartão de crédito, incluindo os cartões do Bmg, ou débito em conta corrente. ",
        },
        {
            question: "Quem pode contratar o Seguro Vida Familiar?",
            answer: "O Seguro Vida Familiar está disponível para clientes Bmg e novos clientes que desejam mais proteção e tranquilidade para seus familiares.",
        },
        {
            question: "Qual a idade permitida para contratação do Seguro Vida Familiar?",
            answer: "O Seguro Vida Familiar pode ser contratado por pessoas de 18 a 80 anos incompletos.",
        },
        {
            question: "Quais assistências podem ser usadas pelos familiares?",
            answer: `O seguro Vida Familiar tem benefícios exclusivos que podem ser usados pelo titular e por até 3 familiares. São eles:

Assistência Medicamento: Remédio grátis ilimitado em casos de urgência e emergência e 3 utilizações de R$100 por ano para consultas agendadas; e
Assistência Funeral: Orientações e serviço de assistência funeral no valor de R$5.000 para o titular e seus familiares nos momentos mais difíceis.`
        },
    ]

    const getSubHeader = () => (<section style={{ zIndex: 5 }} className="hidden md:flex bg-[#462A71] w-full px-4 py-2 flex items-center justify-center gap-5 fixed">
        <a href="#WhatIsBmgMed" className="text-white hover:opacity-[0.7] text-sm">O que é o Bmg Med?</a>
        <a href="#BmgMedPlans" className="text-white hover:opacity-[0.7] text-sm">Planos Bmg Med</a>
        <a href="#WhatIsFamilyLifeInsurance" className="text-white hover:opacity-[0.7] text-sm">O que é o Seguro Vida Familiar?</a>
        <a href="#WhyTakeOutFamilyLifeInsurance" className="text-white hover:opacity-[0.7] text-sm">Por que contratar o Seguro Vida Familiar?</a>
        <a href="#Faq" className="text-white hover:opacity-[0.7] text-sm">Ajuda</a>
    </section>)

    const onGoToRegister = () => navigate('/register');

    return {
        faqs,
        getSubHeader,
        onGoToRegister
    }
}